import { jsx as j } from "react/jsx-runtime";
import { createContext as G, useContext as H, useState as h, useEffect as p, useRef as A, useCallback as U } from "react";
import { bffFetchTrustpilotStoreReviews as _, bffFetchTrustpilotProductReviews as $ } from "@made-people/grease-bff";
const O = G(null), y = ({
  children: t,
  productReviews: e = null,
  storeReviews: r = null,
  isLoading: n = !1,
  siteLanguage: i,
  bffClient: o,
  storeReviewsFetchOptions: a
}) => /* @__PURE__ */ j(
  O.Provider,
  {
    value: {
      productReviews: e,
      storeReviews: r,
      isLoading: n,
      siteLanguage: i,
      bffClient: o,
      storeReviewsFetchOptions: a
    },
    children: t
  }
), k = () => {
  const t = H(O);
  if (!t)
    throw new Error(
      "useTrustpilotContext must be used within a TrustpilotProvider"
    );
  return t;
}, S = (t = "product") => {
  const { productReviews: e, storeReviews: r } = k(), n = t === "product" ? e : r, [i, o] = h(
    typeof n == "function" ? null : n
  );
  return p(() => {
    typeof n == "function" && n().then(o);
  }, [t]), i;
}, m = (t = "product") => {
  const e = S(t);
  return (e == null ? void 0 : e.averageRating) ?? 0;
}, tt = (t = "product") => {
  const e = S(t);
  return (e == null ? void 0 : e.totalReviews) ?? 0;
}, et = (t = "product", e) => {
  const r = S(t);
  return r != null && r.reviews ? e ? r.reviews.slice(0, e) : r.reviews : [];
}, E = (t) => {
  const e = t.content ?? t.text ?? void 0;
  return {
    id: t.id,
    author: t.consumer.displayName,
    date: t.createdAt,
    text: e,
    title: t.title,
    rating: t.stars,
    isVerified: t.isVerified ?? !1
  };
}, q = (t) => {
  if (t.length === 0)
    return 0;
  const e = t.reduce((r, n) => r + n.stars, 0);
  return Math.round(e / t.length * 10) / 10;
}, V = (t) => {
  const e = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0
  };
  return t.forEach((r) => {
    r.stars >= 1 && r.stars <= 5 && e[r.stars]++;
  }), e;
}, z = (t, e) => {
  var i, o;
  if (!((i = t == null ? void 0 : t.productReviews) != null && i.length))
    return null;
  const r = (e == null ? void 0 : e.numberOfReviews.total) ?? ((o = t.links) == null ? void 0 : o.total) ?? t.productReviews.length;
  return {
    averageRating: (e == null ? void 0 : e.starsAverage) ?? q(t.productReviews),
    totalReviews: r,
    reviews: t.productReviews.map(E),
    starDistribution: V(t.productReviews)
  };
}, J = (t, e) => {
  var o, a, u;
  if (!((o = t == null ? void 0 : t.reviews) != null && o.length))
    return null;
  const r = ((a = e == null ? void 0 : e.score) == null ? void 0 : a.trustScore) ?? q(t.reviews), n = (e == null ? void 0 : e.numberOfReviews.total) ?? ((u = t.links) == null ? void 0 : u.total) ?? t.reviews.length, i = e ? {
    1: e.numberOfReviews.oneStar ?? 0,
    2: e.numberOfReviews.twoStars ?? 0,
    3: e.numberOfReviews.threeStars ?? 0,
    4: e.numberOfReviews.fourStars ?? 0,
    5: e.numberOfReviews.fiveStars ?? 0
  } : V(t.reviews);
  return {
    averageRating: r,
    totalReviews: n,
    reviews: t.reviews.map(E),
    starDistribution: i
  };
}, b = 12, K = ({
  currentReviews: t,
  availableReviews: e,
  perPage: r,
  totalReviews: n
}) => {
  const i = e.slice(
    t.length,
    t.length + r
  ), o = [...t, ...i], a = o.length < e.length, u = n ? o.length < n : !1;
  return {
    newReviews: o,
    hasMore: a || u
  };
}, Q = async (t, e, r) => {
  var g;
  const { siteLanguage: n, nextPage: i, perPage: o, currentReviews: a, totalReviews: u } = t;
  if (!e)
    return console.error("[useTrustpilotPagination] bffClient is required"), null;
  const f = ((g = n.split("-")[0]) == null ? void 0 : g.toLowerCase()) || "en", s = await _(e, {
    ...r,
    language: f,
    page: i,
    perPage: o
  });
  if (!(s != null && s.reviews) || s.reviews.length === 0)
    return null;
  const l = J(s);
  if (!l)
    return null;
  const c = [...a, ...l.reviews], v = u ? c.length < u : s.reviews.length === o;
  return {
    newReviews: c,
    hasMore: v,
    nextPage: i
  };
}, W = async (t, e) => {
  var g;
  const {
    productSku: r,
    siteLanguage: n,
    nextPage: i,
    perPage: o,
    currentReviews: a,
    totalReviews: u
  } = t;
  if (!e)
    return console.error("[useTrustpilotPagination] bffClient is required"), null;
  if (!(r != null && r.trim()))
    return console.error(
      "[useTrustpilotPagination] productSku is required for product reviews"
    ), null;
  const f = ((g = n.split("-")[0]) == null ? void 0 : g.toLowerCase()) || "en", s = await $(e, {
    productSku: r.trim(),
    language: f,
    page: i,
    perPage: o
  });
  if (!(s != null && s.productReviews) || s.productReviews.length === 0)
    return null;
  const l = z(s);
  if (!l)
    return null;
  const c = [...a, ...l.reviews], v = u ? c.length < u : s.productReviews.length === o;
  return {
    newReviews: c,
    hasMore: v,
    nextPage: i
  };
}, rt = (t) => {
  const {
    siteLanguage: e,
    bffClient: r,
    storeReviewsFetchOptions: n
  } = k(), { initialReviews: i, totalReviews: o, availableReviews: a, type: u, productSku: f } = t, s = e ?? "en-US", [l, c] = h(i), [v, g] = h(1), [P, R] = h(!0), [T, x] = h(!1);
  p(() => {
    c(i), g(1);
    const w = o ? i.length < o : i.length >= b;
    R(w);
  }, [i, o]);
  const C = A(l), M = A(v);
  p(() => {
    C.current = l;
  }, [l]), p(() => {
    M.current = v;
  }, [v]);
  const I = U(async () => {
    if (!(T || !P)) {
      x(!0);
      try {
        const w = C.current;
        if (a && w.length < a.length) {
          const L = K({
            currentReviews: w,
            availableReviews: a,
            perPage: b,
            totalReviews: o
          });
          c(L.newReviews), R(L.hasMore);
          return;
        }
        const N = M.current + 1, D = {
          siteLanguage: s,
          nextPage: N,
          perPage: b,
          currentReviews: w,
          totalReviews: o,
          productSku: f
        };
        if (!r) {
          console.error(
            "[useTrustpilotPagination] bffClient is required for API requests"
          ), R(!1);
          return;
        }
        let d = null;
        if (u === "store" ? d = await Q(
          D,
          r,
          n
        ) : u === "product" && (d = await W(D, r)), !d) {
          R(!1);
          return;
        }
        c(d.newReviews), R(d.hasMore), g(d.nextPage);
      } catch (w) {
        console.error(
          "[useTrustpilotPagination] Error loading more reviews:",
          w
        ), R(!1);
      } finally {
        x(!1);
      }
    }
  }, [
    u,
    f,
    o,
    a,
    s,
    T,
    P,
    r
  ]);
  return {
    reviews: l,
    loadMore: I,
    canLoadMore: P,
    isLoading: T
  };
}, F = (t) => ({
  author: t.consumer.displayName,
  datePublished: t.createdAt,
  reviewBody: t.text,
  reviewRating: {
    ratingValue: t.stars,
    bestRating: 5,
    worstRating: 1
  }
}), B = (t) => {
  if (t.length === 0)
    return 0;
  const e = t.reduce((r, n) => r + n.stars, 0);
  return Math.round(e / t.length * 10) / 10;
}, nt = (t) => {
  var n, i;
  if (!((n = t == null ? void 0 : t.productReviews) != null && n.length))
    return null;
  const e = t.productReviews.map(F);
  return {
    ratingValue: B(t.productReviews),
    reviewCount: ((i = t.links) == null ? void 0 : i.total) ?? t.productReviews.length,
    reviews: e,
    bestRating: 5,
    worstRating: 1
  };
}, it = (t) => {
  var n, i;
  if (!((n = t == null ? void 0 : t.reviews) != null && n.length))
    return null;
  const e = t.reviews.map(F);
  return {
    ratingValue: B(t.reviews),
    reviewCount: ((i = t.links) == null ? void 0 : i.total) ?? t.reviews.length,
    reviews: e,
    bestRating: 5,
    worstRating: 1
  };
};
export {
  y as TrustpilotProvider,
  z as transformTrustpilotProductReviewsToDisplay,
  nt as transformTrustpilotProductReviewsToStructuredData,
  J as transformTrustpilotStoreReviewsToDisplay,
  it as transformTrustpilotStoreReviewsToStructuredData,
  m as useTrustpilotAverageRating,
  k as useTrustpilotContext,
  rt as useTrustpilotPagination,
  tt as useTrustpilotReviewCount,
  S as useTrustpilotReviews,
  et as useTrustpilotReviewsList
};
